// 注意：Vue 2 需确保引入的是完整版/运行时版（webpack 配置已处理 alias 则无需担心）
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import qs from 'qs'

// ElementUI 核心引入（必须先引入样式）
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 第三方插件引入
import { VueJsonp } from 'vue-jsonp'    // 解构引入正确
import VueClipboard from 'vue-clipboard2'
import moment from 'moment'
import axios from "./api/api"; // 自定义封装的axios
import UtilLz from "./common/utilLz.js";

// 样式/资源引入
import '@/assets/iconfont/iconfont.css'

// 图片预览插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

// Base64 引入（正确写法）
const Base64 = require('js-base64').Base64

// ========== 插件注册：关键修复 —— 分开调用 Vue.use ==========
// 1. ElementUI 注册
Vue.use(ElementUI)
// 2. VueJsonp 注册
Vue.use(VueJsonp)
// 3. VueClipboard 注册
Vue.use(VueClipboard)
// 4. Viewer 注册 + 配置（修复 Options 层级错误）
Vue.use(Viewer)
Viewer.setDefaults({
  inline: true,
  button: true,
  navbar: true,
  title: false,
  toolbar: true,
  tooltip: true,
  movable: true,
  zoomable: true,
  rotatable: true,
  scalable: true,
  transition: true,
  fullscreen: true,
  keyboard: true,
  url: "data-source"
});

// ========== 全局原型挂载 ==========
// 日期工具
Vue.prototype.$moment = moment;
// 自定义axios
Vue.prototype.$axios = axios;
// 自定义工具类
Vue.prototype.$utilLz = UtilLz;
// qs 序列化
Vue.prototype.$qs = qs;
// Base64 挂载到原型（修复：不是写在 Vue 实例配置里）
Vue.prototype.$Base64 = Base64;

// ========== Vue 全局配置 ==========
// 关闭生产环境提示（规范写法）
Vue.config.productionTip = false;
// 全局错误捕获：定位具体运行时错误（关键！解决 Script error 不明确的问题）
Vue.config.errorHandler = function (err, vm, info) {
  console.error('【Vue 运行时错误】:', err);
  console.error('【错误位置】:', info);
  // 用 ElementUI 提示用户（避免白屏）
  vm.$message.error(`页面加载出错：${err.message || '未知错误'}`);
};
// 全局脚本错误捕获
window.onerror = function (msg, url, line, col, err) {
  console.error('【全局脚本错误】:', err || msg);
  console.error('【错误文件】:', url, '【行号】:', line);
};

// ========== 创建 Vue 实例：修复 Base64 错误 ==========
new Vue({
  el: '#app', // 等价于 $mount('#app')，二选一即可（推荐 el 更规范）
  router,
  store,
  render: h => h(App) // Vue 2 渲染函数（webpack 配置了 runtimeCompiler 则可用 template）
  // 注意：Base64 已挂载到原型，无需写在这里！
})

// 如果你习惯用 $mount，也可以这样写：
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')